// extracted by mini-css-extract-plugin
module.exports = {"slots":"Slots_slots__2A7lu","slotItem":"Slots_slotItem__sndG0","host":"Slots_host__GAZcd","text":"Slots_text__XMTot","title":"Slots_title__4ZkDT","hosts":"Slots_hosts__9k7jg"};